var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "24px",
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCC2FA63-3A1F-4202-BA5F-280E5C10ACBD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subscription",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HK-Full---Plans---6:BillingCreditCards",
    transform: "translate(-64.000000, -104.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Total-Due-Section-Copy-3",
    transform: "translate(48.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa-icon",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 40,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Visa_2021",
    transform: "translate(8.000000, 8.000000)",
    fill: "#1434CB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6320724,0 C13.9279831,0 12.4051264,0.872338933 12.4051264,2.48405207 C12.4051264,4.33238272 15.1059705,4.46004615 15.1059705,5.3885962 C15.1059705,5.77956916 14.6523047,6.12955133 13.8774618,6.12955133 C12.7778082,6.12955133 11.9559236,5.6405211 11.9559236,5.6405211 L11.6042513,7.26691762 C11.6042513,7.26691762 12.5510469,7.68 13.808065,7.68 C15.6711801,7.68 17.1372303,6.76482954 17.1372303,5.12555715 C17.1372303,3.17246236 14.4251329,3.0485931 14.4251329,2.18674382 C14.4251329,1.8804725 14.7975535,1.5448916 15.5701781,1.5448916 C16.4419335,1.5448916 17.1531729,1.90054995 17.1531729,1.90054995 L17.4973429,0.329725104 C17.4973429,0.329725104 16.723453,0 15.6320724,0 L15.6320724,0 Z M0.0412628926,0.118553019 L0,0.355658585 C0,0.355658585 0.71691518,0.485242706 1.36261329,0.743733783 C2.19400363,1.04014658 2.25322835,1.2127027 2.3932479,1.74865426 L3.91903715,7.5577425 L5.96436392,7.5577425 L9.11534855,0.118553019 L7.07471078,0.118553019 L5.05001561,5.17649782 L4.22381984,0.889146344 C4.14805047,0.398462352 3.76425445,0.118553019 3.29446708,0.118553019 L0.0412628926,0.118553019 Z M9.9359174,0.118553019 L8.33510473,7.5577425 L10.2810254,7.5577425 L11.8762114,0.118553019 L9.9359174,0.118553019 Z M20.7889964,0.118553019 C20.3197637,0.118553019 20.0711478,0.366663824 19.8887151,0.80023152 L17.0378242,7.5577425 L19.0784619,7.5577425 L19.4732727,6.43149059 L21.9593622,6.43149059 L22.1994372,7.5577425 L24,7.5577425 L22.4291965,0.118553019 L20.7889964,0.118553019 L20.7889964,0.118553019 Z M21.0543919,2.12839373 L21.6592686,4.91994214 L20.038762,4.91994214 L21.0543919,2.12839373 L21.0543919,2.12839373 Z",
    id: "path3789"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaCard);
export default __webpack_public_path__ + "static/media/visa-card.28226403b557924d16c3e0222a6c9798.svg";
export { ForwardRef as ReactComponent };